import _throttle from 'lodash/throttle';
import EventListener from 'modules/mixins/eventListener';

export default class GlobalDrawerMenu {
  constructor() {
    $(document).ready(this.setDrawerAction);
  }

  setDrawerAction() {
    if (!$('.drawer')[0] || !$('.drawer-toggle')[0]) {
      return;
    }

    new Vue({
      el: '.js-global-drawer-menu',
      name: 'GlobalDrawerMenu',
      mixins: [EventListener],
      data() {
        return {
          isActive: false,
          toggle: 'drawer-toggle',
          // overlay: 'drawer-overlay',
          open: 'drawer-open',
          // close: 'drawer-close',
          searchField: 'search-field',
          drawerNav: null,
          lastY: 0,
        };
      },
      mounted() {
        this.drawerNav = document.querySelector('.drawer-nav');
        const $toggles = Array.from(document.getElementsByClassName(this.toggle));
        $toggles.forEach(($toggle) => {
          this.$listen($toggle, 'click', this.handleToggle);
        });
        this.$listen(window, 'resize', _throttle(this.handleClose, 16));
      },
      methods: {
        submitSearchForm(e) {
          if (!e.target.value) {
            return;
          }
          document.getElementById('menuSearchForm').submit();
        },
        handleToggle() {
          if (this.isActive) {
            this.handleClose();
          } else {
            this.handleOpen();
          }
        },
        handleClose() {
          this.isActive = false;
          document.body.classList.remove(this.open);
          document.removeEventListener('touchmove', this.invalidTouchMove, { passive: false });
          document.removeEventListener('touchstart', this.setTouchStartY);
        },
        handleOpen() {
          this.isActive = true;
          document.body.classList.add(this.open);
          document.addEventListener('touchmove', this.invalidTouchMove, { passive: false });
          document.addEventListener('touchstart', this.setTouchStartY);
        },
        invalidTouchMove(e) {
          if (this.drawerNav && this.drawerNav.contains(e.target)) {
            const currentY = e.changedTouches[0].screenY;
            const isUp = this.lastY < currentY;
            const isDown = this.lastY > currentY;
            const isTop = isUp && (this.drawerNav.scrollTop === 0);
            const remainingScroll = this.drawerNav.scrollHeight - this.drawerNav.scrollTop;
            const isBottom = isDown && remainingScroll === this.drawerNav.clientHeight;
            this.lastY = currentY;
            if (isTop || isBottom) {
              e.preventDefault();
            }
            return;
          }
          e.preventDefault();
        },
        setTouchStartY(e) {
          this.lastY = e.changedTouches[0].screenY;
        },
      },
    });
  }
}
